export default {
  add_items: 'Añadir artículos',
  remove_items: 'Quitar artículos',
  place_order: 'Realizar pedido',
  pay_now: 'Pagar ahora · {{amount}}',
  go_to_menu: 'Ir al menú',
  secure_checkout: 'Pago seguro...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Pago fallido',
      description: 'Verifica tu información de pago e inténtalo de nuevo.',
    },
    internal_error: {
      title: 'Pedido no completado 😔',
      description: 'Hubo un problema inesperado con tu pedido, nuestro equipo técnico ya está trabajando en ello 🛠️.',
    },
    order_blocked: {
      title: 'Pedido bloqueado',
      description:
        'Hemos detectado actividad sospechosa en tu cuenta y bloqueamos nuevos pedidos hasta {{datetime}}. Contacta con soporte en {{supportEmail}} para más detalles.',
      description_no_datetime:
        'Hemos detectado actividad sospechosa en tu cuenta y bloqueamos nuevos pedidos. Contacta con soporte en {{supportEmail}} para más detalles.',
    },
  },

  toasts: {
    input_errors_found: 'Hay algunos problemas con la información de tu pedido',
    select_payment_method: 'Elige un método de pago para realizar tu pedido.',
  },
};
